import { render, staticRenderFns } from "./PnetMessageNew.vue?vue&type=template&id=3cbc2c56"
import script from "./PnetMessageNew.vue?vue&type=script&lang=js"
export * from "./PnetMessageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cbc2c56')) {
      api.createRecord('3cbc2c56', component.options)
    } else {
      api.reload('3cbc2c56', component.options)
    }
    module.hot.accept("./PnetMessageNew.vue?vue&type=template&id=3cbc2c56", function () {
      api.rerender('3cbc2c56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pnetmessage/PnetMessageNew.vue"
export default component.exports